import React, { useEffect, useState } from 'react';
import { Form, Button, Spinner } from 'react-bootstrap';
import { useGet } from "../../customHooks/useGet";
import { usePut } from "../../customHooks/usePut";
import { FaDelete, FaSave, FaTimesCircle, FaTrash } from "react-icons/fa";
import { post, get } from "../../services/Services";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from "react-toastify";

const EventEdit = ({ eventId, setShowForm, refetch }) => {
  const [provinces, setProvinces] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [errors, setErrors] = useState({});
  const { data: categoriesData } = useGet("/api/academy/categories?page=0&size=80");
  const { data: modalitiesData } = useGet("/api/academy/modalities?page=0&size=80");
  const { data: formsData, isLoading: loadingForms } = useGet('/api/academy/forms?page=0&size=80');
  const { data: eventData, isLoading: loadingEvent } = useGet(`/api/academy/events/${eventId}`);
  const { executePut: putEvent, error: putError, loading: putLoading } = usePut();
  const forms = formsData?.content || [];
  const [initialCityId, setInitialCityId] = useState(null);
  const [formData, setFormData] = useState({
    city: "",
    competitionNumber: "",
    name: '',
    description: '',
    categoryIds: [],
    modalityIds: [],
    state: 'active',
    startDate: '',
    endDate: '',
    registrationStart: '',
    registrationEnd: '',
    paymentConditions: [],
    eventForms: [],
    priceChoreography: '',
  });

  useEffect(() => {
    async function fetchProvinces() {
      try {
        const response = await get("https://ectech-software.com.ar/api/core/provinces?page=0&size=5000");
        setProvinces(response.data.content || []);
      } catch (error) {
        console.error("Error cargando provincias:", error);
      }
    }
    fetchProvinces();
  }, []);

  const handleProvinceChange = (e) => {
    setSelectedProvince(e.target.value);
    // También puedes guardar esta info en formData si quieres enviarla al backend
    setFormData((prev) => ({
      ...prev,
      provinceId: e.target.value,
      cityId: "",  // Resetear ciudad al cambiar provincia
    }));
  };
  const handleCityChange = (e) => {
    const cityId = parseInt(e.target.value);
    const selected = cities.find((city) => city.id === cityId);
    setSelectedCity(cityId);
    setFormData((prev) => ({
      ...prev,
      city: selected || null, // guardás el objeto completo
    }));
  };
  useEffect(() => {
  async function fetchCities() {
    if (!selectedProvince) {
      setCities([]);
      setSelectedCity("");
      return;
    }
    try {
      const response = await get(`https://ectech-software.com.ar/api/core/provinces/${selectedProvince}/cities?page=0&size=5000`);
      const loadedCities = response.data.content || [];
      setCities(loadedCities);

      // Si tenemos ciudad inicial guardada y esta provincia coincide,
      // seteamos selectedCity al valor guardado y limpiamos initialCityId
      if (initialCityId) {
        const cityExists = loadedCities.some(city => city.id === initialCityId);
        if (cityExists) {
          setSelectedCity(initialCityId);
        } else {
          setSelectedCity("");
        }
        setInitialCityId(null);
      } else {
        setSelectedCity("");
      }
    } catch (error) {
      console.error("Error cargando ciudades:", error);
      setCities([]);
      setSelectedCity("");
    }
  }
  fetchCities();
}, [selectedProvince, initialCityId]);

  useEffect(() => {
    if (eventData && eventData.config) {
      const config = eventData.config;
      const paymentConditions = Array.isArray(config.paymentConditions)
        ? config.paymentConditions.map(cond => {
          if (cond.discountPercentage > 0) {
            return {
              type: 'discount',
              amount: cond.discountPercentage,
              dueDate: cond.endDate,
              minPerformances: cond.minPerformances || 0
            };
          } else if (cond.interestPercentage > 0) {
            return {
              type: 'interest',
              amount: cond.interestPercentage,
              dueDate: cond.endDate,
              minPerformances: 0
            };
          } else {
            return {
              type: 'normal',
              amount: 0,
              dueDate: cond.endDate,
              minPerformances: 0
            };
          }
        })
        : [];
      const eventForms = Array.isArray(config.forms)
        ? config.forms.map(f => ({
          formId: f.id,
          price: f.price
        }))
        : [];
      // 🔽 NUEVO: obtenemos ciudad y provincia
      const cityId = config.city?.id || "";
      const provinceId = config.city?.province?.id || "";
      setSelectedProvince(provinceId);
      setSelectedCity(cityId);
      setFormData({
        name: eventData.name || '',
        description: '',
        competitionNumber: config.competitionNumber || '',
        categoryIds: Array.isArray(config.categories) ? config.categories.map(c => c.id) : [],
        modalityIds: Array.isArray(config.modalities) ? config.modalities.map(m => m.id) : [],
        state: config.status?.name === 'Abierto' ? 'active' : 'inactive',
        startDate: config.eventDate ? config.eventDate.split('T')[0] : '',
        endDate: config.eventEndDate ? config.eventEndDate.split('T')[0] : '',
        registrationStart: config.registrationStartDate ? config.registrationStartDate.split('T')[0] : '',
        registrationEnd: config.registrationEndDate ? config.registrationEndDate.split('T')[0] : '',
        city: cityId,
        provinceId: provinceId,
        paymentConditions,
        eventForms,
        priceChoreography: config.priceChoreography,
      });
    }
  }, [eventData]);
  const options = {
    categories: categoriesData?.content || [],
    modalities: modalitiesData?.content || [],
    forms: formsData?.content || [],
  };
  const capitalizeWords = (str) => {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    let val = value;
    if (type === "checkbox") {
      val = checked;
    } else if (type === "number") {
      // Si quieres puedes convertir a número o dejar cadena para permitir borrar
      val = value === '' ? '' : Number(value);
    } else if (type === "text") {
      val = capitalizeWords(value);
    }
    setFormData(prev => ({
      ...prev,
      [name]: val,
    }));
  };
  const handleFormSelection = (id, isChecked) => {
    setFormData((prev) => {
      const formToAdd = options.forms.find((f) => f.id === id);
      const updatedForms = isChecked
        ? [...prev.eventForms, { formId: formToAdd.id, price: 0 }]
        : prev.eventForms.filter((form) => form.formId !== id);
      return { ...prev, eventForms: updatedForms };
    });
  };
  const handlePriceChange = (formId, price) => {
    setFormData(prev => {
      const updatedForms = prev.eventForms.map(f =>
        f.formId === formId ? { ...f, price: parseFloat(price) || 0 } : f
      );
      return { ...prev, eventForms: updatedForms };
    });
  };
  const handlePaymentConditionChange = (index, field, value) => {
    const updated = [...formData.paymentConditions];
    if (field === 'type') {
      updated[index] = {
        ...updated[index],
        type: value,
        discountPercentage: value === "discount" ? updated[index].discountPercentage || "" : 0,
        interestPercentage: value === "interest" ? updated[index].interestPercentage || "" : 0,
        minPerformances: value === "discount" ? updated[index].minPerformances || "" : 0,
      };
    } else {
      updated[index][field] = value;
    }
    setFormData(prev => ({ ...prev, paymentConditions: updated }));
  };
  const handleAddPaymentCondition = () => {
    setFormData(prev => ({
      ...prev,
      paymentConditions: [
        ...prev.paymentConditions,
        {
          type: 'normal',
          amount: 0,
          endDate: '',
          discountPercentage: 0,
          interestPercentage: 0,
          minPerformances: 0
        }
      ],
    }));
  };
  const handleRemovePaymentCondition = (index) => {
    if (formData.paymentConditions.length > 1) {
      const updated = [...formData.paymentConditions];
      updated.splice(index, 1);
      setFormData(prev => ({ ...prev, paymentConditions: updated }));
    }
  };
  const handleFormPriceChange = (formId, price) => {
    const updated = formData.eventForms.filter(f => f.formId !== formId);
    updated.push({ formId, price: parseFloat(price) });
    setFormData(prev => ({ ...prev, eventForms: updated }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Función para convertir la fecha a formato ISO de manera segura
      const convertToISO = (date) => {
        const parsedDate = new Date(date);
        return parsedDate instanceof Date && !isNaN(parsedDate) ? parsedDate.toISOString() : null;
      };
      // Crear el payload en el formato correcto
      const payload = {
        name: formData.name,
        config: {
          city: formData.city,
          competitionNumber: formData.competitionNumber,
          eventDate: convertToISO(formData.startDate),  // Convertir a formato ISO si es válido
          eventEndDate: convertToISO(formData.endDate), // Convertir a formato ISO si es válido
          registrationStartDate: convertToISO(formData.registrationStart), // Convertir a formato ISO si es válido
          registrationEndDate: convertToISO(formData.registrationEnd), // Convertir a formato ISO si es válido
          categories: formData.categoryIds && formData.categoryIds.length > 0
            ? formData.categoryIds.map(id => ({ id }))
            : [{ id: 1 }], // Valor predeterminado si no se seleccionan categorías
          modalities: formData.modalityIds && formData.modalityIds.length > 0
            ? formData.modalityIds.map(id => ({ id }))
            : [{ id: 1 }], // Valor predeterminado si no se seleccionan modalidades
          status: { id: formData.state === 'active' ? 1 : 2 },
          priceChoreography: formData.priceChoreography,
          forms: formData.eventForms.map(f => ({
            id: f.formId,
            price: f.price
          })),
          paymentConditions: formData.paymentConditions.map(cond => {
            const base = {
              endDate: convertToISO(cond.dueDate), // Convertir a formato ISO si es válido
              minPerformances: cond.type === 'discount' ? cond.minPerformances || 0 : 0,
              status: cond.status // Agregado para asegurar que se pase el status
            };
            if (cond.type === 'discount') {
              return {
                ...base,
                discountPercentage: cond.amount,
                interestPercentage: 0
              };
            } else if (cond.type === 'interest') {
              return {
                ...base,
                interestPercentage: cond.amount,
                discountPercentage: 0
              };
            } else {
              return {
                ...base,
                discountPercentage: 0,
                interestPercentage: 0
              };
            }
          })
        }
      };
      // Enviar el payload a la API
      await putEvent(`/api/academy/events/${eventId}`, payload);
      toast.success("Evento actualizado con éxito");
      refetch?.(); // Re-fetch de los eventos
      setShowForm(false); // Cerrar el formulario
    } catch (err) {
      console.error('Error updating event', err);
      toast.error("Error al actualizar el evento");
    }
  };
  const handleChangeUpperCase = (e) => {
    const { name, type, checked, value } = e.target;
    const transformValue = () => {
      if (type === "checkbox") return checked;
      // Si es competition_number → todo en mayúscula
      if (name === "competitionNumber") return value.toUpperCase();
      // Para otros campos → capitalizar palabras
      return capitalizeWords(value);
    };
    setFormData((prev) => ({
      ...prev,
      [name]: transformValue(),
    }));
  };
  return (
    <div className="container mt-4">
      <div className="card shadow-lg p-4 w-100" style={{ maxWidth: "800px", margin: "auto" }}>
        <div className="card-header bg-warning text-white text-center">
          <h5 className="mb-0">Editar Evento</h5>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </div>
        <div className="card-body"></div>
        <h6 className="mt-3">Información General</h6>
        <Form onSubmit={handleSubmit}>
          <div className="form-floating mb-3">
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={`form-control ${errors.name ? "is-invalid" : ""}`}
            />
            <label htmlFor="name">Nombre del evento</label>
            {errors.name && <div className="invalid-feedback">{errors.name}</div>}
          </div>
          <div className="form-floating mb-3">
            <input
              type="date"
              id="startDate"
              name="startDate"
              value={formData.startDate}
              onChange={handleChange}
              className={`form-control ${errors.startDate ? "is-invalid" : ""}`}
            />
            <label htmlFor="startDate">Fecha de inicio</label>
            {errors.startDate && <div className="invalid-feedback">{errors.startDate}</div>}
          </div>
          <div className="form-floating mb-3">
            <input
              type="date"
              id="endDate"
              name="endDate"
              value={formData.endDate}
              onChange={handleChange}
              className={`form-control ${errors.endDate ? "is-invalid" : ""}`}
            />
            <label htmlFor="endDate">Fecha de fin</label>
            {errors.endDate && <div className="invalid-feedback">{errors.endDate}</div>}
          </div>
          <div className="form-floating mb-3">
            <input
              type="date"
              id="registrationStart"
              name="registrationStart"
              value={formData.registrationStart}
              onChange={handleChange}
              className={`form-control ${errors.registrationStart ? "is-invalid" : ""}`}
            />
            <label htmlFor="registrationStart">Fecha de inicio de registro</label>
            {errors.registrationStart && <div className="invalid-feedback">{errors.registrationStart}</div>}
          </div>
          <div className="form-floating mb-3">
            <input
              type="date"
              id="registrationEnd"
              name="registrationEnd"
              value={formData.registrationEnd}
              onChange={handleChange}
              className={`form-control ${errors.registrationEnd ? "is-invalid" : ""}`}
            />
            <label htmlFor="registrationEnd">Fecha de fin de registro</label>
            {errors.registrationEnd && <div className="invalid-feedback">{errors.registrationEnd}</div>}
          </div>
          {/* Categorías */}
          <h6 className="mt-4">Categorías</h6>
          <div className="mb-3">
            <select
              multiple
              className="form-select"
              value={formData.categoryIds.map((id) => id.toString())}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  categoryIds: Array.from(e.target.selectedOptions).map((opt) => parseInt(opt.value)),
                }))
              }
            >
              {options.categories.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          <h6 className="mt-4">Modalidades</h6>
          <div className="mb-3">
            <select
              multiple
              className="form-select"
              value={formData.modalityIds.map((id) => id.toString())}// Asegúrate de que `formData.modalities` sea un arreglo de objetos con `{ id, name }`
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  modalityIds: Array.from(e.target.selectedOptions).map((opt) => parseInt(opt.value)),
                }))
              }
            >
              {options.modalities.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          {/*Formas*/}
          <h6 className="mt-4">Formas y Precios</h6>
          <div className="mb-3">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Seleccionar</th>
                  <th>Forma</th>
                  <th>Precio (ARS)</th>
                </tr>
              </thead>
              <tbody>
                {forms.map((form) => {
                  const selectedForm = formData.eventForms.find(f => f.formId === form.id);
                  return (
                    <tr key={form.id}>
                      <td>
                        <input
                          type="checkbox"
                          checked={!!selectedForm}
                          onChange={(e) => handleFormSelection(form.id, e.target.checked)}
                        />
                      </td>
                      <td>{form.name}</td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          onChange={(e) => handlePriceChange(form.id, e.target.value)}
                          placeholder="$0.00"
                          disabled={!selectedForm}
                          value={selectedForm ? selectedForm.price : ''}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {/* Condiciones de Pagos */}
          <Form.Group className="mb-4">
            <Form.Label>Condiciones de Pago</Form.Label>
            <div className="table-responsive">
              <table className="table table-bordered align-middle">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "15%" }}>Tipo</th>
                    <th style={{ width: "15%" }}>%</th>
                    <th style={{ width: "20%" }}>Fecha Límite</th>
                    <th style={{ width: "20%" }}>Mín. Obras</th>
                    <th style={{ width: "15%" }}>Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.paymentConditions.map((cond, i) => (
                    <tr key={i}>
                      <td>
                        <Form.Select
                          value={cond.type}
                          onChange={(e) => handlePaymentConditionChange(i, 'type', e.target.value)}
                        >
                          <option value="normal">Normal</option>
                          <option value="discount">Descuento</option>
                          <option value="interest">Interés</option>
                        </Form.Select>
                      </td>
                      <td>
                        <Form.Control
                          type="number"
                          placeholder="Importe / %"
                          value={cond.amount}
                          onChange={(e) =>
                            handlePaymentConditionChange(i, 'amount', parseFloat(e.target.value))
                          }
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="date"
                          value={cond.dueDate}
                          onChange={(e) =>
                            handlePaymentConditionChange(i, 'dueDate', e.target.value)
                          }
                        />
                      </td>
                      <td>
                        {cond.type === 'discount' ? (
                          <Form.Control
                            type="number"
                            placeholder="Mínimo obras"
                            value={cond.minPerformances || ''}
                            onChange={(e) =>
                              handlePaymentConditionChange(i, 'minPerformances', parseInt(e.target.value))
                            }
                          />
                        ) : (
                          <span className="text-muted">–</span>
                        )}
                      </td>
                      <td>
                        <Button variant="danger" size="sm" onClick={() => handleRemovePaymentCondition(i)}>
                          <FaTrash />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Button variant="secondary" onClick={handleAddPaymentCondition}>
              Agregar condición
            </Button>
          </Form.Group>
          <h6 className="mt-4">Precio de Coreografía</h6>
          <div className="form-floating mb-3">
            <input
              type="number"
              className="form-control"
              id="price_choreography"
              name="priceChoreography"  // CORRECTO aquí
              value={formData.priceChoreography}
              onChange={handleChange}
              min="0"
            />
            <label htmlFor="price_choreography">Precio de Coreografía</label>
          </div>
          <div className="form-check form-switch mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="state"
              checked={formData.state === 'active'}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, state: e.target.checked ? 'active' : 'inactive' }))
              }
            />
            <label className="form-check-label" htmlFor="state">
              Estado: {formData.state === 'active' ? 'Activo' : 'Inactivo'}
            </label>
          </div>
          <h6 className="mt-4">Provincia y Ciudad</h6>
          <div className="mb-3">
            <select
              className="form-select"
              value={selectedProvince}
              onChange={handleProvinceChange}
              aria-label="Seleccione provincia"
            >
              <option value="">Seleccione una provincia</option>
              {provinces.map((prov) => (
                <option key={prov.id} value={prov.id}>
                  {prov.name}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <select
              className="form-select"
              value={selectedCity?.id || ""}
              onChange={handleCityChange}
              disabled={!selectedProvince}
              aria-label="Seleccione ciudad"
            >
              <option value="">Seleccione una ciudad</option>
              {cities.map((city) => (
                <option key={city.id} value={city.id}>
                  {city.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-floating mb-3">
            <div className="form-floating mb-3">
              <input
                type="text"
                id="competitionNumber"
                name="competitionNumber"
                value={formData.competitionNumber}
                onChange={handleChangeUpperCase}
                className={`form-control ${errors.competition_number ? "is-invalid" : ""}`}
              />
              <label htmlFor="name">Número de Certamen</label>
              {errors.competition_number && <div className="invalid-feedback">{errors.competition_number}</div>}
            </div>
          </div>
          <div className="d-flex gap-2">
            <Button type="submit" className="btn btn-primary w-50" variant="primary">
              <FaSave />  Actualizar Evento
            </Button>
            <Button variant="secondary" className="btn btn-primary w-50" onClick={() => setShowForm(false)}>
              <FaTimesCircle /> Cancelar
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};
export default EventEdit;
